import { FetchInit, fetchWithDefaults } from 'enterprise-fetch';

const retryPolicy = {
  retries: 2,
  minTimeout: 400,
  factor: 2,
};

const applyTimeout = (s: number) =>
  process.env.NODE_ENV === 'test' ? 2 * 1000 : s * 1000;

const fetchDefaults = {
  // The timeout to apply to requests that do not supply a timeout option
  timeout: applyTimeout(30),
  // Retry policy for all fetch requests
  retry: retryPolicy,
  // Do retry function to examine failures and apply custom retry logic
  // return true to retry the fetch call
  // doRetry: doRetry(),
} as FetchInit;

export const enhancedFetch = fetchWithDefaults(fetchDefaults);
